/*
 * Get a URL query by key
 */
export default function getURLParameter(nameParam, urlParam) {
    // util for getting params from url
    const url = urlParam || window.location.href;
    const name = nameParam.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
